import { render, staticRenderFns } from "./VerticalNavMenuGroup.vue?vue&type=template&id=31330c9c"
import script from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js"
export * from "./VerticalNavMenuGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports